import EditAutomationLoader from './EditAutomationLoader';

export default EditAutomationLoader;
